import logger from '../../Vendor/inv-logger/logger';

/**
 * This module is used to inspect error responses from Ajax calls and handle known scenarios
 */
function ErrorResponseHandler() {

  var self = this;

  /**
   * Inspect the error response for an unauthorised response or error response with translated error
   * messages and handle as appropriately.
   * @param {*} jqXhr
   */
  self.handleErrorResponse = function (jqXhr) {
    handleUnauthorisedResponse(jqXhr);
    handleTimeoutError(jqXhr);
    parseAndAddErrorMessages(jqXhr);
  };

  /**
   * Log a warning if 401 returned as the user's token has expired / there is an authentication issue
   * @param {*} jqXhr
   */
  function handleUnauthorisedResponse(jqXhr) {

    if (jqXhr.status === 401) {
      logger.logUnauthorizedAccess();
      jqXhr.errorHasBeenLogged = true;
    }
  }

  /**
   * Log specific warning if an AJAX request timed out
   * @param {*} jqXhr
   */
  function handleTimeoutError(jqXhr) {

    if (jqXhr.statusText === 'timeout') {
      logger.logTimeout();
      jqXhr.errorHasBeenLogged = true;
    }
  }

  /**
   * If the error contains translated error messages and the error was due to a bad request that the user
   * can recover from then add the translated error messages directly to the jqXhr object for user by
   * consumers of the repositories.
   * @param {*} jqXhr
   */
  function parseAndAddErrorMessages(jqXhr) {
    let errorObject = jqXhr.responseJSON;

    if (!errorObject) {
      return;
    }

    if (typeof errorObject === 'string') {
      try {
        errorObject = JSON.parse(jqXhr.responseJSON);
      } catch (e) {
        console.info(`Server error response doesn't contain JSON for the standard ErrorModel`);
        return;
      }
    }

    if (errorObject.errorMessages && errorObject.isUserRecoverable) {
      jqXhr.serverErrorMessages = errorObject.errorMessages;
    }
  }
}

export default new ErrorResponseHandler();
